import { v4 as uuidv4 } from 'uuid';
import { deepClone, isBlank } from "@/common/utils";

export const note = {
  state: {
    notes: {
      /*
        uuid:
        title:
        details:
        owner_type:
        owner_uuid,
        created_at,
        updated_at
      */
    },
    site_notes: {

    }
  },
  mutations: {
    insertNote(state, new_note) {
      state.notes[new_note.uuid] = new_note;
    },

    insertSiteNote(state, args) {
      if (state.site_notes[args.site_uuid]) {
        state.site_notes[args.site_uuid].push(args.note_uuid);
      } else {
        state.site_notes[args.site_uuid] = [ args.note_uuid ];
      }
    },

    updateNote(state, payload) {
      const note_uuid = payload.uuid;
      if (state.notes[note_uuid]) {
        state.notes[note_uuid] = payload;
      }
    },

    removeNote(state, note_uuid) {
      console.log("Inside note.module.js, removeNote(): note_uuid ==> ", note_uuid);
      const note = state.notes[note_uuid];
      console.log("Inside note.module.js, removeNote(): note ==> ", note);
      if (note) {
        const site_uuid = note.site_uuid
        delete state.notes[note_uuid];
        state.site_notes[site_uuid] = state.site_notes[site_uuid].filter(function(aUUID) {
          return aUUID !== note_uuid;
        });
        if (isBlank(state.site_notes[site_uuid])) {
          delete state.site_notes[site_uuid]
        }
      }
    },

    removeSiteNotes(state, site_uuid) {
      const note_uuids = state.site_notes[site_uuid];
      note_uuids.forEach(function(note_uuid) {
        delete state.notes[note_uuid];
      });
      delete state.site_notes[site_uuid];
    },

    removeAllNotes(state) {
      state.notes = {};
      state.site_notes = {};
    },

    clearNotesIndex(state) {
      state.site_notes = {};
    }
  },
  actions: {
    addNote({ commit }, payload) {
      //console.log("Inside note.module.js, addNote(), payload ==> ", payload);
      const new_note = payload
      if (!new_note.uuid) {
        new_note.uuid = uuidv4();
        new_note.created_at = new Date().toISOString();
        new_note.updated_at = new Date().toISOString();
        console.log("Inside note.module.js, addNote(), new_note ==> ", new_note);
      }
      commit("insertNote", new_note);
      commit("insertSiteNote", { site_uuid: new_note.site_uuid, note_uuid: new_note.uuid });
      return new_note.uuid;
    },

    modifyNote({ commit }, payload) {
      let note = payload;
      note.updated_at = new Date().toISOString();
      commit("updateNote", note);
    },

    timestampNoteSync({ commit, getters }, note_uuid) {
      const note = getters.getNoteByUUID(note_uuid);
      note.sync_on = new Date().toISOString();
      commit("updateNote", note);
    },

    reindexNotes({ commit, getters }) {
      commit("clearNotesIndex");
      const all_notes = Object.values(getters.allNotes);
      all_notes.forEach(function(note) {
        commit("insertSiteNote", { site_uuid: note.site_uuid, note_uuid: note.uuid });
      })
    },

    deleteNote({ commit }, note_uuid) {
      commit("removeNote", note_uuid);
    },

    deleteNotesByOwner({ getters, dispatch }, owner_uuid) {
      const all_notes = getters.allNotesByOwner(owner_uuid);
      console.log("Inside note.module.js, deleteNotesByOwner(), all_notes ==> ", all_notes);
      all_notes.forEach(function(note) {
        dispatch('deleteNote', note.uuid);
      })
    },

    deleteNotesBySite({ getters, dispatch }, site_uuid) {
      const all_notes = getters.getNotesBySiteUUID(site_uuid);
      console.log("Inside note.module.js, deleteNotesBySite(), all_notes ==> ", all_notes);
      all_notes.forEach(function(note) {
        dispatch('deleteNote', note.uuid);
      })
    },

    clearAllNotes({ commit }) {
      commit("removeAllNotes");
    }
  },
  getters: {
    allNotes(state) {
      return state.notes
    },

    allSiteNotes(state) {
      return state.site_notes
    },

    getNoteByUUID(state) {
      return function(uuid) {
        const note = state.notes[uuid];
        return note ? deepClone(note) : null;
      }
    },

    getNotesBySiteUUID(state, getters) {
      return function(site_uuid) {
        const note_uuids = state.site_notes[site_uuid];
        if (note_uuids) {
          return note_uuids.map(function(note_uuid) {
            return getters.getNoteByUUID(note_uuid);
          });
        } else {
          return []
        }
      }
    },

    nbNotesBySite() {
      return function(owner_uuid) {
        return this.getNotesBySiteUUID(owner_uuid).length
      }
    },

    allNotesByOwner(state) {
      return function(owner_uuid) {
        return Object.values(state.notes).filter(function(note) {
          return note.owner_uuid == owner_uuid;
        })
      }
    },    

    searchNotesBy(state, getters) {
      return function(args) {
        console.log("Inside note.module.js # searchNotesBy() args ==> ", args);
        let notes = (args.site_id) ? getters.getNotesBySiteUUID(args.site_id) : state.notes;
        if (args.asset_id) {
          notes = notes.filter(function(note) {
            return note.owner_uuid == args.asset_id;
          })
        }
        if (args.location_id) {
          notes = notes.filter(function(note) {
            return note.owner_uuid == args.location_id;
          })
        }
        if (args.owner_id) {
          notes = notes.filter(function(note) {
            return note.owner_uuid == args.owner_id; // UUID, no need to worry about owner_type
          });
        }
        return notes;
      }
    },

    getNoteOwner(state, getters) {
      return function(note) {
        return getters.getObjectByUUID(note.owner_type, note.owner_uuid)
      }
    }

  }
}